import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=7273bbd7&scoped=true&"
import script from "./OrderIndex.vue?vue&type=script&lang=js&"
export * from "./OrderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273bbd7",
  null
  
)

export default component.exports